import { Toolbar } from '@kerfjs/ui/toolbar';
import { ToolbarText } from '@kerfjs/ui/toolbar-text';
import type { SafeHtml } from 'kerfjs';

import { type EvidenceSection, evidenceTitles } from './evidence-sections.js';

export function EvidenceDetailToolbar({ active, actions }: { active: EvidenceSection; actions?: SafeHtml }): SafeHtml {
  return (
    <Toolbar
      label="Evidence Detail"
      leading={<ToolbarText text={evidenceTitles[active]} size="xlarge" id="line-evidence-detail-title" />}
      trailing={actions}
    />
  );
}
